<template>
  <div id="app">
    <div
      class="app-wrapper"
      :class="{ collapsed: isCollapsed }"
      v-if="getProfile"
    >
      <div
        class="sidebar"
        @mouseover="showSidebar"
        @mouseout="hideSidebar"
        :class="{ open: isSidebarOpened }"
        v-if="!isLogin"
      >
        <div class="sidebar-inner">
          <div class="grid sidebar-logo cross-center between">
            <span>
              <img src="@/assets/images/logo.svg" class="logo" alt />
            </span>
            <a
              id="sidebar-toggle"
              class="sidebar-toggle"
              href="javascript:void(0);"
              @click.prevent="toggle()"
            >
              <b-icon
                v-if="isCollapsed"
                icon="toggle-switch"
                size="is-small"
              ></b-icon>
              <b-icon v-else icon="toggle-switch-off" size="is-small"></b-icon>
            </a>
          </div>
          <ul class="sidebar-menu">
            <li class="user-profile grid between cross-center">
              <div class="sidebar-title">{{ getUserName }}</div>
              <div class="ava grid center cross-center">{{ getInitials }}</div>
            </li>
            <generateLink v-if="showGenerateLink()"></generateLink>
            <li v-for="item in menuList" :key="item.id">
              <router-link
                :to="{ name: firstLetter(item.link) }"
                class="grid between cross-center"
              >
                <span class="sidebar-title">{{ item.title }}</span>
                <b-icon v-bind:icon="item.icon" custom-size="mdi-18px"></b-icon>
              </router-link>
            </li>
            <li v-if="isAuthenticated" @click="logout">
              <a href="javascript:void(0);" class="grid between cross-center">
                <span class="logout">Выйти</span>
                <b-icon icon="exit-to-app" custom-size="mdi-18px"></b-icon>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="page-container grid">
        <div class="main-content u-16"><router-view /></div>
      </div>
    </div>
  </div>
</template>

<script>
import "@mdi/font/css/materialdesignicons.min.css";
import { mapGetters, mapState } from "vuex";
import { AUTH_LOGOUT } from "@/store/actions/auth";
import generateLink from "@/components/generateLink";
import axios from "axios";
export default {
  data() {
    return {
      links: [
        {
          id: 6,
          title: "Аналитика",
          icon: "finance",
          link: "dashboard",
          isActive: true,
          show: true
        },
        {
          id: 2,
          title: "Заказы",
          icon: "credit-card",
          link: "orders",
          isActive: false,
          show: true
        },
        {
          id: 3,
          title: "Сплиты",
          icon: "rhombus-split",
          link: "splits",
          isActive: false,
          show: true
        },
        {
          id: 4,
          title: "Отчетность",
          icon: "file-document",
          link: "reports",
          isActive: false,
          show: true
        },
        {
          id: 7,
          title: "Финансы",
          icon: "safe",
          link: "finance",
          isActive: false,
          show: true
        },
        {
          id: 5,
          title: "Терминалы",
          icon: "developer-board",
          link: "terminals",
          isActive: false,
          show: true
        },
        {
          id: 8,
          title: "Настройки",
          icon: "settings",
          link: "settings",
          isActive: false,
          show: false
        }
      ],
      polling: null
    };
  },
  components: {
    generateLink
  },
  methods: {
    showGenerateLink() {
      let admin = this.getProfile ? this.getProfile.is_admin : false;
      if (admin) return true;
      else {
        let rights = this.getRights;
        if (rights.length > 0) {
          if (!(rights.indexOf("payment_link_generate") == -1)) return true;
          else return false;
        } else return false;
      }
    },
    toggle: function() {
      this.$store.dispatch("toggleSidebar");
    },
    logout: function() {
      this.$store.dispatch(AUTH_LOGOUT);
    },
    showSidebar: function() {
      this.$store.dispatch("showSidebar");
    },
    hideSidebar: function() {
      this.$store.dispatch("hideSidebar");
    },
    firstLetter(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    newLinks() {
      const rights = this.getRights,
        is_admin = this.getProfile ? this.getProfile.is_admin : false,
        links = this.links;

      if (this.terminalList.length > 0) {
        if (!this.terminalSplit)
          links.find(el => el.link == "splits").show = false;
      }
      // if (is_admin == undefined) return [];
      if (!is_admin) {
        links.find(el => el.link == "dashboard").show =
          rights.indexOf("dashboard") != -1;
        links.find(el => el.link == "reports").show =
          rights.indexOf("reports") != -1;
        links.find(el => el.link == "settings").show =
          rights.indexOf("settings") != -1;
      } else {
        links.forEach(element => {
          element.show = true;
        });
      }
      links.find(el => el.link == "finance").show = is_admin || rights.indexOf("finance") !== -1;
      links.find(el => el.link == "settings").show = is_admin;
      return links;
    }
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "getStatus",
      "getUserName",
      "getRights",
      "getInitials",
      "terminalList",
      "terminalSplit",
      "isAuthenticated",
      "isProfileLoaded",
      "isSidebarOpened",
      "isCollapsed"
    ]),
    menuList() {
      let menu = this.newLinks();

      return menu.filter(item => item.show);
    },
    isLogin() {
      return (
        this.$route.name == "Login" ||
        this.$route.name == "callback" ||
        this.$route.name == "404"
      );
    }
  }
};
</script>

<style lang="sass">
@import "./assets/style/main.sass"

.el-loading-mask.is-fullscreen
  z-index: 3000 !important
  background-color: #ffffff !important
</style>
